var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16651_36560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49988 3.20839L3.32068 4.76839V0.117188H0.455078V13.8836H3.32068V7.35079H7.66948V13.8836H10.5447V6.81799L5.49988 3.20839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54592 8.65137H4.45312V13.8786H6.54592V8.65137Z",
    fill: "#66B927"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16651_36560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGIcon);
export default __webpack_public_path__ + "static/media/g-icon.4261750b85009c8ff91ee78a092801b3.svg";
export { ForwardRef as ReactComponent };